import { WIDGET_CONTROL_TYPE } from '@examdojo/core/widget';
import type { GraphpadWidgetConfig } from '../graphpad.model';

/**
 * Preset for exploring linear functions.
 * Showcases all available features: handle, roots, tangent, derivative.
 */
export const LINEAR_EXPLORATION_PRESET: GraphpadWidgetConfig = {
  id: 'linear-exploration',
  type: 'graphpad',
  params: {
    f: {
      type: 'linear',
      params: { m: 1, b: -2 },
    },
    'f-translate': {
      type: 'handle',
      params: { of: 'f', behavior: 'translate' },
    },
    'f-roots': {
      type: 'roots',
      params: { of: 'f' },
    },
    'f-tangent': {
      type: 'tangent',
      params: { of: 'f', x: 1 },
    },
    'f-derivative': {
      type: 'derivative',
      params: { of: 'f' },
    },
  },
  display: {
    canvas: { color: 'neutral-0' },
    coordinateSystem: {
      boundingbox: { xStart: -8, xEnd: 8, yStart: -8, yEnd: 8 },
      grid: { type: 'lines', visible: false },
    },
    elements: {
      f: {},
      'f-translate': {},
      'f-roots': {
        point: { color: 'indigo' },
      },
      'f-tangent': {
        subparts: {
          touchPoint: {
            point: { color: 'amber', fixed: false },
          },
          tangentLine: { line: { color: 'amber', strokeWidth: 2 } },
        },
      },
      'f-derivative': {
        curve: { color: 'pink', strokeWidth: 2, dash: 2 },
      },
    },
  },
  behavior: {
    controls: [
      {
        id: 'slider-m',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'm (slope)',
        param: 'f.m',
        range: [-5, 5, 0.1],
        defaultValue: 1,
        editable: true,
        color: 'green',
      },
      {
        id: 'slider-b',
        type: WIDGET_CONTROL_TYPE.Slider,
        label: 'b (y-intercept)',
        param: 'f.b',
        range: [-6, 6, 0.5],
        defaultValue: -2,
        editable: true,
        color: 'teal',
      },
    ],
  },
};
